import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Input } from "./index";

const formatChars = {
  // first digit of day
  d: "[0-3]",
  // first digit of month
  m: "[0-1]",
  // first digit of year
  y: "[1-2]",
  9: "[0-9]",
};

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const InputDateRange = forwardRef((props, ref) => {
  const { children, ...otherProps } = props;

  return (
    <Input
      ref={ref}
      formatChars={formatChars}
      mask={{
        mask: "d9.m9.y999-d9.m9.y999",
        char: "_",
      }}
      {...otherProps}
    >
      {children}
    </Input>
  );
});

InputDateRange.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

InputDateRange.displayName = "InputDateRange";

export default InputDateRange;
